import api from "../../../api/axios";

// Feature-local wrappers for /users/me/blocks/ (ACTION-MENUS-UX-B1-11).
// Stateless request functions. No cache, no store, no shared orchestrator.
//
// Backend: apps.users.views.MyBlocksListCreateView / MyBlocksDeleteView
//   GET    /users/me/blocks/
//   POST   /users/me/blocks/          { user_id } | { public_id }
//   DELETE /users/me/blocks/<user_id>/

const BLOCKS_BASE = "/users/me/blocks";

export const listBlocks = (options = {}) =>
  api
    .get(`${BLOCKS_BASE}/`, { signal: options.signal })
    .then((res) => res.data);

export const blockUser = (target) => {
  const body =
    target && typeof target === "object"
      ? target.public_id
        ? { public_id: target.public_id }
        : { user_id: target.user_id ?? target.id }
      : { user_id: target };
  return api.post(`${BLOCKS_BASE}/`, body).then((res) => res.data);
};

export const unblockUser = (userId) =>
  api.delete(`${BLOCKS_BASE}/${userId}/`).then((res) => res.data);
